import { render } from "./PlanTableLanchCard.vue?vue&type=template&id=2e34feaa&ts=true"
import script from "./PlanTableLanchCard.vue?vue&type=script&lang=ts"
export * from "./PlanTableLanchCard.vue?vue&type=script&lang=ts"

import "./PlanTableLanchCard.vue?vue&type=style&index=0&id=2e34feaa&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__